import script from "./Input.vue?vue&type=script&setup=true&lang=js"
export * from "./Input.vue?vue&type=script&setup=true&lang=js"

import "./Input.vue?vue&type=style&index=0&id=4a79dfc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a79dfc4"]])

export default __exports__